var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-md-4" }, [
          _c("div", { staticClass: "p-3 rounded bg-greyish-green" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-8 pr-0" },
                [
                  _c("custom-dropdown", {
                    attrs: {
                      fieldkey: "id",
                      fieldname: "name",
                      options: _vm.academicyears,
                      placeholder: "Seleccione el año"
                    },
                    model: {
                      value: _vm.selectedAcademicYear,
                      callback: function($$v) {
                        _vm.selectedAcademicYear = $$v
                      },
                      expression: "selectedAcademicYear"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("action-button", {
                    attrs: {
                      i: "fas fa-search",
                      text: "Buscar",
                      variant: "success w-100"
                    },
                    on: { click: _vm.onSearch }
                  })
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _c("icon-view", {
        staticClass: "my-3 icon-view-color-text",
        attrs: {
          icon: "far fa-history color-orange p-5",
          "icon-size": "1.5rem",
          title: "Historial de PEI",
          variant: "icon-view-extended"
        }
      }),
      _vm.peiHistoryData.length > 0
        ? _c(
            "div",
            { staticClass: "search-result mt-3" },
            [
              _vm._l(_vm.peiHistoryData, function(row) {
                return _c("pei-history-row", {
                  key: `${row.peiIdFormatted}`,
                  ref: "pei",
                  refInFor: true,
                  attrs: {
                    "has-saee10-report": row.hasSaee10Report,
                    value: row
                  },
                  on: {
                    getReportsPEIPS: function($event) {
                      return _vm.getReportsPEIPS(row)
                    },
                    getReportsPEIPSFromStorage: function($event) {
                      return _vm.getReportsPEIPSFromStorage(row)
                    }
                  }
                })
              }),
              _vm.pagination.totalItemCount > _vm.pagination.perPage
                ? _c("pagination", {
                    attrs: {
                      data: _vm.pagination,
                      "page-size": _vm.pagination.perPage
                    },
                    on: { "pagination-go-page": _vm.onPageChanged }
                  })
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }